import { useEffect, useRef } from "react";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { selectSpaValue } from "../../redux/selectors";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const PreviewResults = () => {
  const spaValue = useAppSelector(selectSpaValue);
  const { selectedId } = useStorageSelectors("ai_agents_spa");
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (!iframeRef.current) return;
    const currentContent = spaValue?.spa_object?.html_content || "";

    iframeRef.current.srcdoc = currentContent;
  }, [spaValue?.spa_object?.html_content, selectedId]);

  return (
    <div className={styles["preview-container"]}>
      <iframe ref={iframeRef} className={styles.frame} />
    </div>
  );
};
